import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
// import AddMaster from "./AddMaster";
// import EditMaster from "./EditMaster";
import { adminMainUrl } from '../../../../Config';
import { getJobOrderList } from '../../../../Redux/action/Joborder/JoborderAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import { DDMMMYYYYformateDate } from '../../../../HelperFunctions';
import axios from 'axios';
// import { DesignationApi } from '../../../../Redux/action/MasterAction';

const JobOrderMasterCCSI = ({ title, trans_mode, service_type, impexp, accessedModules, accessedPermission }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showLoader, setShowLoader] = useState([]);
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    useEffect(() => {
        if (token && user_id) {
            dispatch(getJobOrderList(token, user_id, trans_mode, service_type, impexp));
        } else {
            toast.error("Please login to continue.")
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, q]);

    const {
        loadingJobOrderList,
        JobOrderList,
        JobOrderListError
    } = useSelector(state => state?.JoborderReducer);

    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        if (loadingJobOrderList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (JobOrderList) {
            let arr = [];
            JobOrderList.map((val, i) => {
                arr.push({
                    key: i, // Add a unique key for each row
                    SNo: i + 1,
                    Joborderno: val?.job_order_unique_no, // Ensure date formatting as neede
                    Trackingno: val?.tracking_no,
                    Date: DDMMMYYYYformateDate(val?.createdAt),
                    Transportmode: val?.trans_mode,
                    Transporttype: val?.trans_type,
                    shipment_type: val?.cc_id ?
                        "Console Shipment" :
                        val?.ff_id ?
                            val?.ff_type == "Direct MAWB" ?
                                "Direct" :
                                val.ff_type == "Console HAWB" ?
                                    "Console" :
                                    "-"
                            : "-"
                    ,
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    {accessedPermission.includes("edit_job_order") && <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/edit/${btoa(val?.id)}`) }} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit Job Order
                                    </div>}
                                    {service_type == "custom_clearance" ?
                                        val.cc_id ?
                                            accessedPermission.includes("si_edit_custom_clearance") && <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/custom-clearance/export-job/edit/${btoa(val.cc_id)}`) }} >
                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Custom Clearance
                                            </div>
                                            :
                                            accessedPermission.includes("si_add_custom_clearance") && <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/custom-clearance/${trans_mode == "Sea" ? "sea" : "air"}/${impexp == "importer" ? "import" : "export"}/add?j_id=${btoa(val.id)}`) }} >
                                                <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Custom Clearance
                                            </div>
                                        :
                                        service_type == "freight_forwarding" ?
                                            val.ff_id ?
                                                val.ff_type == "Console HAWB" ?
                                                    <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/console/hawb/edit/${btoa(val.ff_id)}`) }} >
                                                        <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit  Console HAWB
                                                    </div> :
                                                    val.ff_type == "Direct MAWB" ?
                                                        <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/direct/mawb/edit/${btoa(val.ff_id)}`) }} >
                                                            <i className="fa-regular fa-clipboard text-blue me-2"></i> Edit Direct MAWB
                                                        </div> :
                                                        <div className="dropdown-item cursor-pointer">
                                                            Network Error
                                                        </div>
                                                :
                                                <div className="dropdown-item cursor-pointer"
                                                    onClick={() => {
                                                        navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/add?j_id=${btoa(val.id)}`)
                                                    }}
                                                >
                                                    <i className="fa-regular fa-clipboard text-blue me-2"></i> Add Freight Forwarding
                                                </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </>
                    )
                })
            });
            setDataSource(arr);

        }
    }, [loadingJobOrderList, JobOrderList])





    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Joborder No.", dataIndex: "Joborderno", key: "Joborderno" },
        { title: "Tracking No.", dataIndex: "Trackingno", key: "Trackingno" },
        { title: "Date", dataIndex: "Date", key: "Date" },
        { title: "Transport Mode", dataIndex: "Transportmode", key: "Transportmode" },
        { title: "Transport Type", dataIndex: "Transporttype", key: "Transporttype" },
        { title: "Shipment Type", dataIndex: "shipment_type", key: "shipment_type" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];



    const handleCheckQuotationCustomClearance = (id) => {
        try {
            const config = {
                headers: {
                    'auth-token': Cookies.get('token'),
                    'user_id': Cookies.get('flexichain_user_id'),
                }
            }

            axios.post(`${adminMainUrl}/api/customClearance/check-cc-exists`, { job_order_id: id }, config)
                .then(res => {
                    if (res.status == 200) {
                        if (res.data.data == true) {
                            navigate(`/flexichain/job-order/freight-forwarding/${trans_mode == "Sea" ? "sea" : "air"}/${impexp == "importer" ? "import" : "export"}/add?j_id=${btoa(id)}`)
                        } else {
                            toast.error("Please add custom clearance details first.")
                        }
                    } else {
                        let msg = 'Internal server error!';
                        if (res.data && res.data.msg) {
                            msg = res.data.msg
                        }
                        toast.error(msg);
                    }
                }).catch((error) => {
                    console.log(error);
                    toast.error(error.message);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }




    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="page-wrapper">
                            <div className="content">
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* Page Header */}
                                        <div className="page-header">
                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h4 className="page-title">
                                                        {title ?? "Job Order List"}<span className="count-title">{JobOrderList?.length ?? "0"}</span>
                                                    </h4>
                                                </div>
                                                <div className="col-4 text-end">
                                                    <div className="head-icons">
                                                        <a
                                                            href="javascript:void(0);"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            data-bs-original-title="Collapse"
                                                            id="collapse-header"
                                                        >
                                                            <i className="ti ti-chevrons-up" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Page Header */}
                                    </div>
                                </div>
                                <div className="card">

                                    <div className="card-body">

                                        {/* Filter */}
                                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                            <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                {/* <div className="dropdown me-2">
                                                    <a
                                                        href="javascript:void(0);"
                                                        className="dropdown-toggle"
                                                        data-bs-toggle="dropdown"
                                                    >
                                                        <i className="ti ti-sort-ascending-2 me-2" />
                                                        Sort{" "}
                                                    </a>

                                                    <div className="dropdown-menu  dropdown-menu-start">
                                                        <ul>
                                                            <li>
                                                                <a href="javascript:void(0);" className="dropdown-item">
                                                                    <i className="ti ti-circle-chevron-right me-1" />
                                                                    Ascending
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);" className="dropdown-item">
                                                                    <i className="ti ti-circle-chevron-right me-1" />
                                                                    Descending
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);" className="dropdown-item">
                                                                    <i className="ti ti-circle-chevron-right me-1" />
                                                                    Recently Viewed
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);" className="dropdown-item">
                                                                    <i className="ti ti-circle-chevron-right me-1" />
                                                                    Recently Added
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div> */}
                                                {/* <div className="icon-form mb-3 mb-sm-0">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search "
                                                        name='search_by'
                                                    />
                                                </div> */}

                                            </div>
                                            <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                {/* <Tooltip placement="top" title="Print Data">
                                                    <div
                                                        className="btn btn-primary cursor-pointer me-2"
                                                    >
                                                        <i className="ti ti-printer text-white"></i>
                                                    </div>
                                                </Tooltip>
                                                <Tooltip placement="top" title="Export Data">
                                                    <div
                                                        className="btn btn-primary cursor-pointer me-2"
                                                    >
                                                        <i className="fas fa-file-export text-white"></i>
                                                    </div>
                                                </Tooltip>
                                                <button type='submit' className="btn btn-primary me-2">
                                                    Search
                                                </button> 
                                                <a
                                                    className='btn btn-light me-2'
                                                >
                                                    Clear
                                                </a>*/}
                                                {service_type == 'custom_clearance' ?
                                                    (trans_mode && impexp && (
                                                        (trans_mode == "Air" && impexp == "importer" && accessedPermission.includes("cc_job_order_list_air_import")) ||
                                                        (trans_mode == "Air" && impexp == "exporter" && accessedPermission.includes("cc_job_order_list_air_export")) ||
                                                        (trans_mode == "Sea" && impexp == "exporter" && accessedPermission.includes("cc_job_order_list_sea_export")) ||
                                                        (trans_mode == "Sea" && impexp == "importer" && accessedPermission.includes("cc_job_order_list_sea_import"))
                                                    )) ?
                                                        <div
                                                            className="btn btn-primary cursor-pointer me-2"
                                                            onClick={() => {
                                                                navigate(`/flexichain/job-order/custom-clearance/${trans_mode == "Sea" ? 'sea' : 'air'}/${impexp == "exporter" ? 'export' : 'import'}/add`)
                                                            }}
                                                        >
                                                            <i className="ti ti-square-rounded-plus me-2" />
                                                            Add Custom Clearance
                                                        </div> : null
                                                    :
                                                    service_type == 'freight_forwarding' ?
                                                        <div
                                                            className="btn btn-primary cursor-pointer me-2"
                                                            // onClick={handleAddShow}
                                                            onClick={() => { navigate("/flexichain/job-order/freight-forwarding/shipment/air/export/add") }}
                                                        >
                                                            <i className="ti ti-square-rounded-plus me-2" />
                                                            Add Freight Forwarding
                                                        </div>
                                                        :
                                                        accessedPermission.includes("create_job_order") && <div
                                                            className="btn btn-primary cursor-pointer me-2"
                                                            // onClick={handleAddShow}
                                                            onClick={() => { navigate("/flexichain/job-order/add") }}
                                                        >
                                                            <i className="ti ti-square-rounded-plus me-2" />
                                                            Add Job Order
                                                        </div>
                                                }

                                            </div>
                                        </div>
                                        <div className="table-responsive custom-table">
                                            <Table className="table datanew dataTable no-footer" pagination={false}
                                                dataSource={dataSource} columns={columns} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>


    )
}

export default JobOrderMasterCCSI